module.exports = __webpack_public_path__ + "img/product_107.4496ecc.webp";